import { render, staticRenderFns } from "./EmployeeTrainings.vue?vue&type=template&id=523e2768&scoped=true"
import script from "./EmployeeTrainings.vue?vue&type=script&lang=js"
export * from "./EmployeeTrainings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523e2768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('523e2768')) {
      api.createRecord('523e2768', component.options)
    } else {
      api.reload('523e2768', component.options)
    }
    module.hot.accept("./EmployeeTrainings.vue?vue&type=template&id=523e2768&scoped=true", function () {
      api.rerender('523e2768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/career/EmployeeTrainings.vue"
export default component.exports